import React, { FC } from 'react'
import { Box, Skeleton } from 'transfix-ui/core'
import { TDonutDatum } from '../types'

interface ILegendLabelProps {
  datum: TDonutDatum
  totalValues: number
  isLoading: boolean
}

export const LegendLabel: FC<ILegendLabelProps> = ({
  datum: { label, value },
  isLoading,
  totalValues,
}) => (
  <Box display='flex' flexDirection='row' justifyContent='space-between'>
    <span>{isLoading ? <Skeleton width={145} /> : label}</span>
    <span>
      {isLoading ? (
        <Skeleton width={42} />
      ) : (
        `${Math.trunc(value)} (${totalValues > 0 ? Math.trunc((value / totalValues) * 100) : 0}%)`
      )}
    </span>
  </Box>
)
